export type FormatEnumValueParams<T extends Record<string | number, any>> = {
    enumKey: keyof T;
    enumMapping: T;
    capitalizeFirstLetter: boolean;
};

export const formatEnumValue = <T extends Record<string | number, any>>(
    input: FormatEnumValueParams<T>
): string | undefined => {
    const { enumKey, enumMapping, capitalizeFirstLetter } = input;
    const entry = enumMapping[enumKey];

    if (!entry) return undefined;

    const result = typeof entry === 'string' ? entry : entry.label;

    return capitalizeFirstLetter
        ? result?.charAt(0)?.toUpperCase() + result?.slice(1)
        : result?.charAt(0)?.toLowerCase() + result?.slice(1);
};
